import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Smartphone, X } from 'lucide-react';
import { toast } from 'sonner';
import { api, errMsg, fmtDateTime } from '../api';
import { Card, ghostBtn, goldBtn } from '../ui';
import ConfirmSend from '../components/ConfirmSend';

const Pill = ({ ok, label, testid }) => (
  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs ${ok ? 'border-[#5FC18F]/50 text-[#5FC18F]' : 'border-[#3A3F47] text-[#7A7F87]'}`} data-testid={testid}>
    {ok ? <Check size={12} /> : <X size={12} />}{label}
  </span>
);

function AppStatus({ s }) {
  return (
    <span className="flex flex-wrap gap-2 mt-2" data-testid="trip-app-status">
      <Pill ok={s.logged_in} label={s.logged_in ? `App attivata${s.first_login_at ? ` il ${fmtDateTime(s.first_login_at)}` : ''}` : 'App non ancora attivata'} testid="trip-app-status-login" />
      <Pill ok={s.push} label={s.push ? 'Avvisi attivi' : 'Avvisi non attivi'} testid="trip-app-status-push" />
      <Pill ok={s.biometric} label={s.biometric ? 'Face ID / impronta' : 'Senza Face ID / impronta'} testid="trip-app-status-bio" />
    </span>
  );
}

export default function TravelerAppInvite({ t, reload, ask = false }) {
  const [open, setOpen] = useState(ask && !!t.traveler_email && !t.app_invited_at);
  const navigate = useNavigate();
  useEffect(() => { if (ask) navigate(window.location.pathname, { replace: true, state: null }); }, [ask, navigate]);
  const send = async () => {
    setOpen(false);
    try { await api.post(`/travel/trips/${t.id}/app-invite`); toast.success(`Invito all'app inviato a ${t.traveler_email}`); reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card className="p-4 mb-4 flex flex-wrap items-center gap-3 text-sm" data-testid="trip-traveler-app">
      <Smartphone size={18} className="text-[#D4AF37] shrink-0" />
      <span className="text-[#A3A3A3] flex-1 min-w-[14rem]">
        App viaggiatore (avvisi, conferma arrivo, pulsante di emergenza).{' '}
        {t.app_invited_at ? <span className="text-[#5FC18F]" data-testid="trip-app-invited">Invito inviato il {fmtDateTime(t.app_invited_at)}</span>
          : t.traveler_email ? 'Invito non ancora inviato.' : "Aggiungi l'email del viaggiatore per inviare l'invito."}
        {t.app_reminded_at && <span className="block text-xs" data-testid="trip-app-reminded">Promemoria di installazione inviato il {fmtDateTime(t.app_reminded_at)}</span>}
        {t.traveler_email && <AppStatus s={t.app_status || {}} />}
      </span>
      <button onClick={() => { navigator.clipboard?.writeText(`${window.location.origin}/viaggiatore`); toast.success('Link copiato'); }} className={`${ghostBtn} h-9 px-3`} data-testid="trip-traveler-app-copy">Copia link</button>
      {t.traveler_email && <button onClick={() => setOpen(true)} className={`${goldBtn} h-9 px-3`} data-testid="trip-app-invite-btn">{t.app_invited_at ? 'Invia di nuovo' : 'Invia invito'}</button>}
      <ConfirmSend open={open} testid="trip-app-invite-confirm" title="Inviare l'invito all'app?" confirmLabel="Invia invito" onConfirm={send} onCancel={() => setOpen(false)}
        text={<><p>Invieremo a <b>{t.traveler_email}</b> un'email con il link all'app BOND Viaggiatore e le istruzioni per installarla e attivare gli avvisi.</p><p>Il link è incluso anche nell'invio della documentazione della trasferta.</p></>} />
    </Card>
  );
}
